export default __webpack_public_path__ + "static/media/bannerbg.4bdada37.svg";